module.exports = __webpack_public_path__ + "static/manufacturing-blog-img-1-89640ec0a182e11260a44a3b0ca4e242.jpg";